import { createFileRoute } from "@tanstack/react-router"

// Import the existing search page
import AffiliateSearchPage from "@/features/jobs/search/components/affiliate-search-page"

export const Route = createFileRoute("/_screen/s/affiliate")({
  component: SearchAffiliatePage
})

function SearchAffiliatePage() {
  return <AffiliateSearchPage />
}
